module.exports = __webpack_public_path__ + "static/media/download.a9d23e87.svg";